export default "__VITE_ASSET__7VOTGuAp__"